import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money } from "../../api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [recentOrders, setRecentOrders] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [s, o] = await Promise.all([api.get("/api/admin/stats"), api.get("/api/admin/orders")]);
        setStats(s.data);
        setRecentOrders(o.data.slice(0, 6));
      } catch {}
    })();
  }, []);

  const cards = [
    { label: "Products", value: stats?.active_products ?? "—", testid: "stat-products" },
    { label: "Orders", value: stats?.total_orders ?? "—", testid: "stat-orders" },
    { label: "New orders", value: stats?.new_orders ?? "—", testid: "stat-new-orders" },
    { label: "Customers", value: stats?.total_customers ?? "—", testid: "stat-customers" },
    { label: "Categories", value: stats?.total_categories ?? "—", testid: "stat-categories" },
    { label: "Revenue", value: stats ? money(stats.revenue) : "—", testid: "stat-revenue" },
  ];

  return (
    <div className="admin-page">
      <div className="admin-page-head">
        <span className="eyebrow">Studio overview</span>
        <h1>Dashboard.</h1>
      </div>
      <div className="stat-grid">
        {cards.map((c) => (
          <div className="stat-card" key={c.label} data-testid={c.testid}>
            <span className="eyebrow">{c.label}</span>
            <strong>{c.value}</strong>
          </div>
        ))}
      </div>
      <section className="dashboard-backup-callout">
        <div>
          <span className="eyebrow">Catalogue protection</span>
          <h2>Keep a restorable copy of every product.</h2>
          <p>Download products, category placements and uploaded catalogue images before each deployment or major edit.</p>
        </div>
        <Link to="/admin/backups" className="button dark-button" data-testid="dashboard-catalog-backup-link">
          Open Catalog Backup
        </Link>
      </section>
      <section className="admin-section">
        <div className="section-head">
          <div>
            <span className="eyebrow">Latest</span>
            <h2>Recent orders</h2>
          </div>
          <Link to="/admin/orders" className="admin-inline-link" data-testid="dashboard-view-orders-link">
            View all
          </Link>
        </div>
        {recentOrders.length ? (
          <div className="admin-table">
            <div className="admin-table-head">
              <span>Order</span>
              <span>Customer</span>
              <span>Total</span>
              <span>Status</span>
            </div>
            {recentOrders.map((o) => (
              <div className="admin-table-row" key={o.id} data-testid={`dashboard-order-${o.order_id}`}>
                <span>{o.order_id}</span>
                <span>{o.customer_name}</span>
                <span>{money(o.total)}</span>
                <span className={`order-status status-${o.status}`}>{o.status}</span>
              </div>
            ))}
          </div>
        ) : (
          <p className="empty-state">No orders yet.</p>
        )}
      </section>
    </div>
  );
}
